import { render, staticRenderFns } from "./GasConfig.vue?vue&type=template&id=feb8563a&lang=html"
import script from "./GasConfig.vue?vue&type=script&lang=js"
export * from "./GasConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports